<div class="attachments-container">
  @for (attachment of attachments; track attachment.uid) {
  <div class="attachments-container__attachment">
    <span class="attachments-container__attachment-name">{{ attachment.title }}</span>
    <div class="attachments-container__attachment-remove" (click)="removeAttachment($index)">
      <mat-icon svgIcon="close_circle"></mat-icon>
    </div>
  </div>
  }
</div>
